import { useEffect, useRef, useState } from "react";

export function useVersion() {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const initialHash = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        if (!initialHash.current) {
          initialHash.current = data.hash;
        } else if (data.hash !== initialHash.current) {
          setHasNewVersion(true);
        }
      } catch (e) {
        // silencioso: version.json puede no existir aún en dev
      }
    };
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, []);

  return { hasNewVersion, reload: () => window.location.reload() };
}
